export const initialDilicomInfo = {
    name: "",
    releaseDate: "",
    price: "",
    format: "",
    pagination: "",
    avatarUrl: "",
    summary: "",
    category: "",
};

export const initialEan13DilicomOption = [
    {
        imgUrl: "",
        title: "",
        ean13: "",
    },
];

export const initialCheckInfo = {
    name: true,
    releaseDate: true,
    price: true,
    format: true,
    pagination: true,
    avatarUrl: true,
    summary: true,
    category: true,
};

export const initialHighlightField = {
    avatarUrl: false,
    name: false,
    summary: false,
    price: false,
    format: false,
    pagination: false,
    releaseDate: false,
    category: false,
};
